import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Mariko Kawachi | Engineer', // e.g: 'Name | Developer'
  lang: 'jp', // e.g: en, es, fr, jp
  description: 'Welcome to my portfolio', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Mariko Kawachi',
  subtitle: 'Web Engineer, Writer, etc...',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'はじめまして。エンジニアのきまり(@Kimaringoo)と申します。社会人歴（IT業界）8年を経験しています。',
  paragraphTwo: '中小企業のSIerに正社員で入社し、企業向けWebアプリケーションの保守運用や社内パッケージシステムの開発に携わりました。その後大手SIerに転職し、多数の企業向けWebアプリケーションの要件定義から開発、保守運用まで携わりました。出産を機に退職し、現在に至ります。',
  paragraphThree: '現在はGatsby、WoedPress、Webデザイン（PhotoShop）、SEO関連を勉強中です。',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project1.png',
    title: 'ポートフォリオ',
    info: 'このサイトです。',
    info2: 'HTML / CSS / Gatsby / Netlify / Github',
    url: 'https://gallant-dijkstra-b1725e.netlify.app',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project2.png',
    title: '情報発信サイト',
    info: '子育て情報発信サイトです。デザインからコーディングまで全て自作しています。',
    info2: 'HTML / CSS / Gatsby / Netlify / Contentful / Github',
    url: 'https://www.kids-programming.org',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project6.png',
    title: '情報発信サイト',
    info: '転職情報発信サイトです。デザインはWordPressテーマ「Coccon」。コーディングは自作しています。',
    info2: 'HTML / CSS / WordPress',
    url: 'https://brank-syuhu-work.com/',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'postcard.jpg',
    title: 'ポストカード風画像',
    info: '勉強用にフリー画像を使用して作成',
    info2: 'PhotoShop',
    url: 'postcard.jpg',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project5.jpg',
    title: 'アイキャッチ画像',
    info: 'ブログ用にサンプルを作成しました',
    info2: 'PhotoShop',
    url: 'project5.jpg',
    repo: '', // if no repo, the button will not show up
  },
{
    id: nanoid(),
    img: 'project4.jpg',
    title: 'アイキャッチ画像',
    info: 'ブログ用にサンプルを作成しました',
    info2: 'PhotoShop',
    url: 'project4.jpg',
    repo: '', // if no repo, the button will not show up
  },
    {
    id: nanoid(),
    img: 'project7.png',
    title: 'アイキャッチ画像',
    info: 'ブログ用にサンプルを作成しました。',
    info2: 'Canva',
    url: 'project7.png',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'eyecatch2.jpg',
    title: 'アイキャッチ画像',
    info: 'ブログ用に作成しました。',
    info2: 'PhotoShop',
    url: 'eyecatch2.jpg',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'top1.jpg',
    title: 'ブログトップ画像',
    info: 'ブログ用にトップ画像を作成しました。',
    info2: 'PhotoShop',
    url: 'top1.jpg',
    repo: '', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'お仕事の依頼などはtwitterかメールへご連絡ください。',
  btn: 'メール送信',
  email: 'kawachi.mariko@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/Kimaringoo',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/marikoku',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: 　false, // set to false to disable the GitHub stars/fork buttons
};
